import React, { useState } from 'react';
import { UserOverlay } from '../../components/UserOverlay';
import { SegmentDefinition } from '@fullstory/proto/fs/api/segment';
import { EventSearch } from '@fullstory/proto/fs/api/search';
import { USER_OVERLAY_ROUTE, RoutePropsFrom } from '@fullstory/routes';
import { useHistory, Route } from 'react-router-dom';
import { Sidecar } from '@fullstory/components';
import { UserOverlayActions } from '@fullstory/redux';
import { useDispatch } from 'react-redux';

type UserOverlayRouteComponentProps = React.ComponentProps<typeof UserOverlay> &
  Pick<React.ComponentProps<typeof Sidecar>, 'onClose'>;

const UserOverlayRouteComponent: React.FunctionComponent<UserOverlayRouteComponentProps> = ({
  onClose,
  ...rest
}) => {
  const [open, setOpen] = useState(true);
  return (
    <Sidecar
      data-component="UserOverlayRouteComponent"
      open={open}
      onClose={() => setOpen(false)}
      onClosed={onClose}
      position="right"
    >
      <UserOverlay {...rest} />
    </Sidecar>
  );
};

export const UserOverlayView: React.FC<{
  segmentDefinition: SegmentDefinition;
  eventSearch?: EventSearch;
  orgId: string;
}> = ({ orgId, segmentDefinition, eventSearch }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  return (
    <Route
      data-component="UserOverlayView"
      path={USER_OVERLAY_ROUTE.path}
      render={(routeProps: RoutePropsFrom<typeof USER_OVERLAY_ROUTE>) => (
        <UserOverlayRouteComponent
          userId={routeProps.match.params.userId}
          orgId={orgId}
          segmentDefinition={segmentDefinition}
          eventSearch={eventSearch}
          onClose={() => {
            dispatch(UserOverlayActions.setSegmentDefinition(null));
            history.push(
              `${location.pathname.replace(`/user/${routeProps.match.params.userId}`, '')}${
                location.search
              }`,
            );
          }}
        />
      )}
    />
  );
};
